import axios from 'axios';
import api from "./ApiClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_PATH = '/foodz/api/v1';

class APILoginService {
    static async login(userCredentials) {
        try {
            const response = await axios.post(`${API_BASE_URL}/foodz/api/v1/login`, userCredentials);

            if (response.status === 200) {
                const user = response.data.user;

                if (!user || !user.role) {
                    console.error("Usuário inválido retornado pelo backend:", user);
                    return false;
                }

                const normalizedUser = {
                    id: user.id,
                    login: user.login || "",
                    name: user.name || "",
                    email: user.email || "",
                    role: user.role,
                    client_code: user.client_code || "",
                    login_code: user.login_code || "",
                    permissions: user.permissions || [],
                    asaasEnabled: user.asaasEnabled || false,
                };

                sessionStorage.setItem("authToken", response.data.token.token);
                sessionStorage.setItem("userId", normalizedUser.id);
                sessionStorage.setItem("login", normalizedUser.login);
                sessionStorage.setItem("name", normalizedUser.name);
                sessionStorage.setItem("email", normalizedUser.email);
                sessionStorage.setItem("role", normalizedUser.role);
                sessionStorage.setItem("clientCode", normalizedUser.client_code);
                sessionStorage.setItem("loginCode", normalizedUser.login_code);

                return { user: normalizedUser, token: response.data.token.token };

            } else {
                console.error('Credenciais inválidas. Por favor, tente novamente.', response.status);
                return false;
            }
        } catch (error) {
            console.error("Login error:", error);
            throw error;
        }
    }

    static async getCurrentUser() {
        const token = sessionStorage.getItem('authToken');
        if (!token) throw new Error("Usuário não autenticado");

        const response = await api.get(`${BASE_PATH}/me`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });

        return response.data;
    }
}


export default APILoginService;